// 储值页活动发优惠券配置
export const ACTIVITY_COUPON_CONFIG = {
  175: {
    // 发券接口配置
    sendCouponApi: {
      name: 'tmslgyhq2', // 活动标识
      action: 'coupon' // 接口
    },
    // 选择商品页面是否发券
    isWebStore: true,
    // 提单页面是否发券
    isStore: false
  },
  251: {
    sendCouponApi: {
      name: 'dlssr1220coupon',
      action: 'coupon'
    },
    isWebStore: true,
    isStore: true
  }
};
